import { render, staticRenderFns } from "./addCustomer.vue?vue&type=template&id=42ad8c5e&scoped=true&"
import script from "./addCustomer.vue?vue&type=script&lang=js&"
export * from "./addCustomer.vue?vue&type=script&lang=js&"
import style0 from "./addCustomer.vue?vue&type=style&index=0&id=42ad8c5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ad8c5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42ad8c5e')) {
      api.createRecord('42ad8c5e', component.options)
    } else {
      api.reload('42ad8c5e', component.options)
    }
    module.hot.accept("./addCustomer.vue?vue&type=template&id=42ad8c5e&scoped=true&", function () {
      api.rerender('42ad8c5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataStatistics/components/addCustomer.vue"
export default component.exports